import React from 'react';
import DateRangePicker from 'react-daterange-picker';
import 'react-daterange-picker/dist/css/react-calendar.css';

const DateRange = ({
    onChange, numberOfCalendars, value, ...rest
}) => {
    const _numberOfCalendars = numberOfCalendars || 1;
    return (
        <DateRangePicker
            locale={
                window.sessionStorage.getItem('locale') ? window.sessionStorage.getItem('locale').replace('no', 'nb') : 'en'
            }
            firstOfWeek={1}
            singleDateRange
            numberOfCalendars={_numberOfCalendars}
            value={value}
            onSelect={onChange}
            {...rest}
        />
    );
};
export default DateRange;
